"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Nmm = void 0;
var _react = require("react");
var _Nmm = require("./Nmm.styles");
var _Nmm2 = require("./Nmm.labels");
var _hooks = require("../../hooks");
var _A = require("../../UI/A");
var _Icon = require("../../UI/Icon");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _jsxRuntime = require("react/jsx-runtime");
var Nmm = function Nmm(props) {
  var techSupportUrl = props.techSupportUrl;
  var styles = (0, _Nmm.useStyles)();
  var getLabel = (0, _hooks.useLabels)({
    labels: _Nmm2.labels
  });
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    language = _useContext.language;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-Nmm'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
      className: styles['cc-Nmm__title'],
      children: getLabel('title')
    }), getLabel('request'), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-Nmm__steps-container'],
      children: [getLabel('steps'), /*#__PURE__*/(0, _jsxRuntime.jsxs)("ol", {
        className: styles['cc-Nmm__steps'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
          children: getLabel('step1')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
          children: getLabel('step2')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
          children: getLabel('step3')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
          children: getLabel('step4')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
          children: getLabel('step5')
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: styles['cc-Nmm__help-container'],
      children: [getLabel('helpStart'), ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
        to: techSupportUrl,
        target: "_blank",
        children: getLabel('helpSupport')
      }), ' ', getLabel('helpEnd')]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
      to: "https://storage.cet.ac.il/cet-components/nmm/files/updateNmm_".concat(language, ".pdf"),
      target: "_blank",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: styles['cc-Nmm__download'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          name: "Download",
          width: 17,
          height: 17
        }), " ", getLabel('explanation')]
      })
    })]
  });
};
exports.Nmm = Nmm;